import React from 'react';
import Icon from '@mui/material/Icon';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export default function EmptyStateCard({ icon, title, desc }) {
  return (
    <MDBox
      sx={{
        p: 2,
        borderRadius: '16px',
        border: '1px dashed rgba(0,0,0,0.15)',
        textAlign: 'center',
      }}
    >
      <MDBox
        sx={{
          width: 44,
          height: 44,
          mx: 'auto',
          borderRadius: '16px',
          display: 'grid',
          placeItems: 'center',
          background: 'rgba(0,0,0,0.06)',
        }}
      >
        <Icon>{icon}</Icon>
      </MDBox>

      <MDTypography variant="button" fontWeight="bold" sx={{ mt: 1 }}>
        {title}
      </MDTypography>

      <MDTypography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.25 }}>
        {desc}
      </MDTypography>
    </MDBox>
  );
}
